import { FC, useState } from 'react';
import loadable from '@loadable/component';
import {
  FavoriteToggleContext,
  FavoriteToggleContextType,
  FavoriteToggleButton,
} from '#baseMenu/components';
import { AdvertFavoriteBottomSheetHolder } from '#advertFavorite/containers';
import { useStateCallbacks } from '#advertFavorite/hooks';

const AdvertFavoriteBottomSheet = loadable(() => import('#advertFavorite/containers/AdvertFavoriteBottomSheet'), {
  resolveComponent: ({ AdvertFavoriteBottomSheet: Component }) => Component,
});

const FavoriteToggle: FC = () => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isLoadInProcess, setIsLoadInProcess] = useState<boolean>(false);
  const stateCallbacks = useStateCallbacks();

  const favoriteToggleContextValue: FavoriteToggleContextType = {
    AdvertFavoriteBottomSheet,
    isLoaded,
    setIsLoaded,
    isLoadInProcess,
    setIsLoadInProcess,
  };

  return (
    <FavoriteToggleContext value={favoriteToggleContextValue}>
      <FavoriteToggleButton />
      <AdvertFavoriteBottomSheetHolder stateCallbacks={stateCallbacks} />
    </FavoriteToggleContext>
  );
};

export { FavoriteToggle };
